// extracted by mini-css-extract-plugin
export default {"sentry":"vDVDgsdO","title":"QaZ0ZLD0","subtitle":"DYSSPDxV","link":"u9XKZYC1","btn":"XUeQWPwm"};